import Filter from "core/filtering/filter";

export default class BookingFilter extends Filter {
    onlyFuture: boolean;
    constructor(filter?: { onlyFuture: boolean; }) {
        super({ $orderby: "StartDate desc" });
        this.onlyFuture = filter?.onlyFuture ?? true;
    }
}
